$(document).ready(function(){

  if( $('.info_icons .icons').length ){ // homepage icons
    $('.info_icons .icons .icon h6').matchHeight();
  }

  if( $('.shopify-section.pressreviews .review_line').length ){ // press reviews, text
    $('.shopify-section.pressreviews .review_line').slick({
      dots: false,
      arrows: false,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      asNavFor: '.shopify-section.pressreviews .press'
    }).show();
  }
  if( $('.shopify-section.pressreviews .press').length ){ // press reviews, logos
    $('.shopify-section.pressreviews .press').slick({
      mobileFirst: true,
      dots: false,
      centerMode: false,
      asNavFor: '.shopify-section.pressreviews .review_line',
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      focusOnSelect: true,
      vertical: true,
      responsive: [
      {
        breakpoint: 640,
        settings: {
          vertical: false
        }
      }
    ]
    }).show();
  }

  if( $('.collection_nav').length ){ // collection nav
    $(window).scroll(function(){
      var scrollPos = $(document).scrollTop() + 150;
      $('.collection_nav a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
          $('.collection_nav a').removeClass("active");
          currLink.addClass("active");
        }
        else{
          currLink.removeClass("active");
        }
      });

      let sections = document.querySelectorAll(".collection--items");
      sections.forEach((section) => {
        var id = section.id;
        let observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if ( entry.intersectionRatio == 1 ) { // in view, scroll to div
                $('.collection_nav .container').animate({ scrollLeft: $('.collection_nav a[href="#'+ id).position().left}, 100);
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(section);
      });
    });
  }

  // intelligems stuff
  if( $('.add_single').length ){
    var $btn = $('.add_single.btn');
    var free_gift_id = $btn.attr('freegift_id');
    window.addEventListener('ig:ready', () => {
      const campaigns = window.igData?.campaigns.getAll();
      if (campaigns.length){
        free_gift_id = campaigns[0].discount.tiers[0].giftWithPurchaseVariantId;
        $btn.attr('freegift_id', free_gift_id);
      }
    });
  }

  // free gift, no variant fix
  $('body').on('click', '.add_single', function(){
    let fg_id = $(this).attr('freegift_id');
    push_to_queue(fg_id, 1, {_free_gift: "true"});

    setTimeout(function(){
      Shopify.moveAlong();
    }, 400);
  });

  if( $('ul.countries').length ){
    $('.country_selector').click(function(){
      $(this).find('.countries').slideToggle();
      $(this).find('.main .bi-chevron-down').toggleClass('active');
    });

    $(document).mouseup(function(e){
    var container = $(".country_selector");
      if (!container.is(e.target) && container.has(e.target).length === 0){
        container.find('.countries').slideUp();
      }
    });
  }

  if( $('.product_icons .orderby').length ){ // if orderby is dynamic
    // moment().locale('en');
    var extradays = 0;
    var maximum = $('.product_icons .orderby .content').data('maxdays');
    var date = new Date();
    date.setDate( date.getDate() + maximum );

    if ( date.getDay() == 0 ){ // sunday
      extradays = 1;
      console.log('Sunday Delivery - add 1 day to be sure.');
    }
    var total = maximum + extradays;
    var toDate = moment().add( total , 'days');
    document.getElementById('toDate').innerHTML = toDate.format('dddd Do MMMM');
  }

  if( $('.no-stock_messaging .shipping_date').length ){
    // moment().locale('en');
    var daysfrom_today = 10;
    var currentdate = new Date();

    if ( currentdate.getDay() == 0 ){
     daysfrom_today = daysfrom_today + 1;
    }
    currentdate.setDate( currentdate.getDate() + daysfrom_today );

    var shipping_date = moment().add( daysfrom_today , 'days');
    shipping_date = shipping_date.format('Do MMMM');

    $('.no-stock_messaging .shipping_date').append(shipping_date);
  }

  $('.swatches img').click(function(){
    var url = $(this).parent('.swatch').attr('data-url');
    var hoverImage = $(this).attr('data-image');

    $(this).closest('.product').find('.image_holder').attr('href', url);
    $(this).closest('.product').find('.btn').attr('href', url);
    $(this).closest('.product').find('.product-item-img').attr('src', hoverImage);
  });

  $('body').removeClass('loading-skeleton');

  if( $('.no-stock_messaging').length ){
    moment().locale(shop_config.iso_code);
    var daysfrom_today = 10;
    var date = new Date();

    if ( date.getDay() == 0 ){
     daysfrom_today = daysfrom_today + 1;
   }
   date.setDate( date.getDate() + daysfrom_today );

   var shipping_date = moment().add( daysfrom_today , 'days');
   shipping_date = shipping_date.format('Do MMMM');

   $('.no-stock_messaging .shipping_date, .oos_messaging .shipping_date').append(shipping_date);
  }

  if( $('.towel_benefits .slider').length ){ // towel product benefit slider
    $('.card h3').matchHeight();
    $('.card p').matchHeight();

    $('.towel_benefits .cards.slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('.towel_benefits .next'),
      dots: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    }).show();

    $('.towel_benefits .cards.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('.towel_benefits .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('.towel_benefits .progress .slider__label').text( calc + '% completed' );
    });
  }

  if( $('.product-testimonials .slider').length ){ // product review testimonials
    $('.product-testimonials .slider').slick({
      mobileFirst: true,
      dots: false,
      slidesToShow: 1,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 5000,
      prevArrow: $('.product-testimonials .prev'),
      nextArrow: $('.product-testimonials .next'),
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    }).show();

    $('.product-testimonials .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('.product-testimonials .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('.product-testimonials .progress .slider__label').text( calc + '% completed' );
    });
  }

  if( $('.page--reviews-slider:not(.product-reviews) .slider').length ){ // page reviews
    $('.page--reviews-slider:not(.product-reviews) .slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('.page--reviews-slider:not(.product-reviews) .next'),
      dots: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    }).show();

    $('.page--reviews-slider:not(.product-reviews) .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('.page--reviews-slider:not(.product-reviews) .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('.page--reviews-slider:not(.product-reviews) .progress .slider__label').text( calc + '% completed' );
    });
  }

  if( $('.product-item').length ){ // products in collection, match heights
    $('.product-item h3').matchHeight();
    $('.product-item .product-item-includes').matchHeight();

    $('.product:not(.clearance) .image_holder:not(.cta_image)').matchHeight();
    $('.cta .image_holder.cta_image, .product:not(.clearance)').matchHeight();

    $('.product-item .image_holder').hover( function(){
      $(this).find('.hover_img').addClass('active');
    }, function(){
      $(this).find('.hover_img').removeClass('active');
    });

  }

  if( $('.call_to_actions .slider').length ){ // call to actions slider
    $('.call_to_actions .slider').slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    }).show();
  }

  if( $('.call_to_actions .slider-long').length ){ // call to actions slider -- HOME LONGFORM
    $('.call_to_actions .slider-long').slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
    }).show();
  }

  if( $('.blog--collections').length ){ // collections slider
    $('.blog--collections .product .content h5').matchHeight();
    $('.blog--collections .product .content p').matchHeight();

    $('.blog--collections .slider').slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    }).show();
  }

  if( $('.blog-template--main').length ){ // blog posts
    $('.article__featured-image').matchHeight();
    $('.article--indiv .blog-main--article-title').matchHeight();
    $('.article--indiv .rte').matchHeight();
  }

  if( $('.blocks').length ){ // offers page blocks
    $('.blocks .block .content h3').matchHeight();
    $('.blocks .block .content p:first-of-type').matchHeight();
    $('.blocks .block .content p small').matchHeight();
  }

  if( $('.homebanner').length ){ // home slide
    $('.homebanner').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 500
    }).show();
  }

  $('.announcement-bar .slider').slick({ // announcement bar slider
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    mobileFirst: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          cssEase: 'linear',
          variableWidth: true,
          autoplaySpeed: 0,
          speed: 18000,
          centerMode: true
        }
      }
    ]
  }).show();


  if( $('.product-image-slider .slider').length ){ // call to actions slider
    $('.product-image-slider .slider').slick({
      mobileFirst: true,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    }).show();
  }  
});
